<template>
<div> 
    <div class="content personal bgimg-box" v-if="!uploaded">
      <div class="condition-box" style="white-space: pre-wrap;" v-html="round.round_introduce"></div>
      <div class="form-box" v-loading="loading">
        <el-form ref="form" :model="memberData" label-width="120px" :rules="rules">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="memberData.name" placeholder="请输入真实姓名"></el-input>
          </el-form-item>
          <!-- <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="memberData.sex">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
          </el-form-item> -->
          <el-form-item label="手机" prop="mobile">
            <el-input v-model="memberData.mobile" placeholder="请输入手机"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="memberData.email" placeholder="请输入邮箱"></el-input>
          </el-form-item>
          <!-- <el-form-item label="身份" prop="is_cima">
              <el-radio v-model="memberData.is_cima" :label="1">在读CIMA方向班学生</el-radio>
              <el-radio v-model="memberData.is_cima" :label="2">无</el-radio>
          </el-form-item>
           <el-form-item label="CIMA学员ID" prop="cima_sn">
            <el-input v-model="memberData.cima_sn" placeholder="请输入CIMA学员ID"></el-input>
          </el-form-item>
           <el-form-item label="赛区" prop="area" class="saiqu-box">
            <el-select v-model="teamData.area" placeholder="请选择赛区" style="width:60%;float:left;">
              <el-option 
                v-for="item in areas"
                :key="item.id"
                :value="item.id"
                :label="item.name"
              ></el-option>
            </el-select>
             <el-tooltip content="Bottom center" placement="bottom" effect="light"  style="float:left">
              <div slot="content">华北赛区（北京、天津、河北、山西、辽宁、黑龙江、吉林、内蒙古）<br/>华东及西北赛区（上海、江苏、浙江、安徽、山东、江西、陕西、甘肃、宁夏、青海、新疆）
                <br>华南赛区（广东、广西、湖南、福建、海南）
                <br>西南和华中赛区（四川、重庆、河南、湖北、云南、贵州、西藏）</div>
                <span class="more">
                  了解赛区详情
                <i class="el-icon-question"></i>
              </span>
            </el-tooltip>
          
          </el-form-item>
           <el-form-item label="院校所在省份" prop="city">
            <el-select v-model="memberData.city" placeholder="请选择院校所在省份">
              <el-option 
                v-for="item in citys" 
                :key="item.id"
                :value="item.id"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="学校" prop="school">
            <el-input v-model="memberData.school" placeholder="请输入学校"></el-input>
          </el-form-item>
          <el-form-item label="学院" prop="college">
            <el-input v-model="memberData.college" placeholder="请输入学院"></el-input>
          </el-form-item>
          <el-form-item label="年级" prop="grade">
            <!-- <el-input v-model="memberData.grade" placeholder="请输入年级"></el-input> -->
            <el-select v-model="memberData.grade" placeholder="请选择年级">
              <el-option 
                v-for="item in grades" 
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="推荐人" prop="recommend_member">
            <el-input v-model="memberData.recommend_member" placeholder="若无推荐人请写无"></el-input>
          </el-form-item>
          <el-form-item label="收货地址" prop="city_id">
            <el-cascader
              v-model="memberData.city_id"
              placeholder="所在城市"
              :options="citys"
              :props="{ expandTrigger: 'hover', value:'id',label:'name', children:'children', emitPath:false }"></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址" prop="address">
            <el-input v-model="memberData.address" placeholder="详细地址"></el-input>
            <div class="ala-tip" style="color: #999;font-size: 13px;">*用于GBC礼包发放，礼包将于7个工作日发送</div>
          </el-form-item>
          <!-- <el-form-item label="上传照片" prop="" v-if="round.round_id == 5">
            <el-upload
              class="avatar-uploader"
              :headers="uploadHeader"
              :action="imageUrl + '/user/upload'"
              :data="{file_source:1}"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              accept=".jpg,.png,.jpeg"
            >
              <img v-if="memberData.photo_file_id" :src="imageUrl + imgPath" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item> -->
          <!-- <el-form-item prop="accept" class="text">
            <el-checkbox v-model="accept">同意并接受 <el-link target="_blank" href="https://www.cimaglobal.com/Privacy-Policy/">CIMA隐私政策</el-link></el-checkbox>
          </el-form-item> -->
          <el-form-item style="width:600px" class="but-box">
              <el-button class="next" :loading="subLoading" @click="next">下一步</el-button>
              <!-- <el-button class="cancel">取消</el-button> -->
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="status-box" v-else>
      <!-- <div class="img-box" v-if="round.round_id === 1">
        <div class="title-wrap">
            <p class="blod">CGMA商业精英国际挑战赛</p>
            <p class="second">2021GBC商业二精英挑战赛</p>
        </div>
         <p style="color: #999;font-size: 16px;padding-bottom: 14px;">打开钉钉扫码，快速加入2021GBC商业精英挑战赛</p>
         <img v-show="round.round_id === 1" class="qrcode" :src="imageUrl + url" alt="">
        
        <p v-show="round.round_id === 1" style="line-height: 40px;font-size: 16px;">
           4月10日上午10时至晚上8时（第一轮）<br>
           4月12日上午10时至晚上8时（第二轮）<br>
            <el-button type="text" size="small" @click="simple" style="color:#733085">查看样题</el-button></p>
      </div> -->
      <div class="img-box">
        <img src="../../assets/images/team/submit.png" alt="" />
        <p>报名信息已提交成功！</p>
        <!-- <el-button class="next">下一步</el-button> -->
      </div>
    </div>
</div>
</template>

<script>
import {
  apiGetCity,
  apiSetProcess,
  apiGetOssConfig,
  apiGetReportTeamData,
  apiSubPersonalInfo,
  apiGetSubPersonalInfo,
  apiGetCities
} from '../../plugins/apis'
export default { 
  data () {
    return {
      accept:false,
      uploadHeader:{ Authorization: window.localStorage.cima_registration_token },
      imageUrl: process.env.VUE_APP_API_URL,
      url:'',
      citys:[],
      // address:[],
      grades:[
        {label: '大一', value:'大一'},
        {label: '大二', value:'大二'},
        {label: '大三', value:'大三'},
        {label: '大四', value:'大四'},
      ],
      rules:{
        name: [
            { required: true, message: "请输入真实姓名", trigger: ["blur","change"] },
        ],
        mobile: [
          {
            required:true,
            validator: (rule, value, callback) => {
              let mobileNumRegx = new RegExp(
                  /^1[3456789]{1}[0-9]{9}$/
              );
              if (value === "") {
                  callback(new Error("请输入手机号码"));
              } else if (!mobileNumRegx.test(value)) {
                  callback(new Error("手机号码格式不正确"));
              } else {
                  callback();
              }
            },
            trigger: ["blur","change"],
          },
        ],
        
        email: [
            { required: true, message: "请输入邮箱", trigger: ["blur","change"] },
        ],
        school: [
            { required: true, message: "请输入所在学校", trigger: ["blur","change"] },
        ],
        college: [
            { required: true, message: "请输入所在学院", trigger: ["blur","change"] },
        ],
        major: [
            { required: true, message: "请输入专业", trigger: ["blur","change"] },
        ],
        grade: [
            { required: true, message: "请输入年级", trigger: ["blur","change"] },
        ],
        city_id: [
            { required: true, message: "请选择所在城市", trigger: ["blur","change"] },
        ], 
        is_cima: [
            { required: true, message: "请选择身份", trigger: ["blur","change"] },
        ],
        // address:[
        //   {
        //     required:true,
        //     validator: (rule, value, callback) => {
        //       if(this.address.length < 2){
        //           callback(new Error("请选择收货地址"));
        //       }else{
        //           callback();
        //       }
        //     },
        //     trigger: ["blur","change"],
        //   },
        // ],
        address:[
            { required: true, message: "请输入收货地址", trigger: ["blur","change"] },
        ],
        recommend_member: [
          {
            required: true,
            message: "请输入推荐人",
            trigger: ["blur", "change"],
          },
        ]
        
      },
      memberData: {
        name: "",
        // sex: 1,
        school: "",
        college: "",
        // major: "",
        grade: "",
        // city: "",
        mobile: "",
        email: "",
        // is_cima:2,
        // cima_sn:'',
        address:'',
        recommend_member: '',
        city_id: null,
        province_id: null,
      },
      teamData:{},
      areas:[
        {id:1,name:'华北赛区'},
        {id:2,name:'华东及西北赛区'},
        {id:3,name:'华南赛区'},
        {id:4,name:'西南和华中赛区'},
      ],
      imgPath:'',
      uploaded:false,
      loading:false,
      subLoading:false,
    }
  }, 
  methods: { 
    handleChange(){

    },
    simple(){
      window.open('http://api.gbc.cncima.com/storage/Sample-GBC.pdf')
    },
    async getConfig(){
          let res = await apiGetOssConfig()
          if(res.code === 200){
              this.url = res.data.system_dingding
          }
      },
    async getTeam(){
      let res = await apiGetReportTeamData(this.round.round_id)
      if(res.code === 200){
        this.teamData = Array.isArray(res.data.teamData) ? {} : res.data.teamData 
        this.memberArr = res.data.memberData || [] 
        if(this.memberArr.length > 0){
          this.uploaded = true
        } 
      }
    },
    handleAvatarSuccess(res) {
      if(res.code === 200){
        this.$set(this.memberData,'photo_file_id',res.data.file_id)
        this.imgPath = res.data.file.path
        this.$message.success('上传成功')
      }
    },
    async getCity(){
      let res = await apiGetCity()
      if(res.code === 200){
        this.citys = res.data
      }
    },
    async next (){

      this.$refs.form.validate(async (valid) => {
        if (valid) {
          // if(!this.accept){
          //   this.$message.error("请同意并接受相关隐私政策")
          //   return 
          // }
          await this.sub()
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      
    },
    async sub(){
      // this.memberData.address_province = this.address[0]
      // this.memberData.address_city = this.address[1]
      // let _data = [this.memberData]
      this.subLoading = true
      if(this.memberData.city_id) {
        this.memberData.province_id = this.citys.find(item => item.children.find(city => city.id === this.memberData.city_id)).id
      }
      
      let res = await apiSubPersonalInfo(this.memberData)
      if(res.code === 200){
        this.$message.success("提交成功")
        this.uploaded = true
        // await this.getTeam()
        this.subLoading = false
        await apiSetProcess(this.round.round_id,this.label)
        setTimeout(() => {
          this.$Bus.$emit("reload_NowProcess")
        }, 1000);
      }else{
        this.subLoading = false
        this.$message.error(res.message)
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isJPG && isLt2M;
    },
    async getPersonalInfo () {
      const res = await apiGetSubPersonalInfo()
      if(res.code === 200){
        if(res.data.data) {
          this.memberData = res.data.data
          this.$refs.form.resetFields()
        }
      }
    },
    async getCities () {
      const res = await apiGetCities()
      if(res.code === 200){
        this.citys = res.data
      }
    },
  },
  async mounted () {
    this.loading = true
    await this.getPersonalInfo()
    await this.getCities()
    // await this.getCity()
    // await this.getTeam()
    // await this.getConfig()
    this.loading = false
  },
  props:['round','label']
}
</script> 

<style scoped>
.bgimg-box{
    background-color: #FFFFFF !important;
    background: url('../../assets/images/team/bg.png') no-repeat bottom right;
  }
  .qrcode{
        width: 200px;
        height: 200px;
    }
    /* .saiqu{
    display: flex;
    
  } */
  .el-tooltip{
    font-size: 12px;
  }
  /* .saiqu-box .el-select{
    width: 70%;
  } */
  .more{
    cursor: pointer;
    margin-left: 5px;
  }
  .more:hover{
    text-decoration: underline;
    color:#733085;
  }
  .title-wrap{
    display: inline-block;
    border-bottom: 2px dashed  #999;
    margin-bottom: 20px;
  }
  .title-wrap .blod{
    font-weight: 600;
    font-size: 24px;

  }
  .title-wrap .second{
    margin:10px 0 20px 0;
    font-size: 18px;
    color: #999;
  }
</style>
